import styled from 'styled-components'

export const Grid = styled.section`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  @media (max-width: 1240px) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  @media (max-width: 820px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 520px) { grid-template-columns: 1fr; }
`;
export const Card = styled.article`
  min-width: 0;
  min-height: 272px;
  display: flex;
  flex-direction: column;
  padding: 22px;
  border: 1px solid ${({ theme }) => theme.palette.colors.cardBorder};
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.colors.cardSurface};
  box-shadow: ${({ theme }) => theme.palette.colors.cardShadow};
  transition: border-color 0.18s ease, transform 0.18s ease;
  &:hover, &:focus-within { border-color: ${({ theme }) => theme.palette.colors.borderStrong}; transform: translateY(-2px); }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;
export const Logo = styled.img`
  width: auto;
  max-width: 142px;
  height: 44px;
  object-fit: contain;
  object-position: left center;
  border-radius: 3px;
`;
export const LogoFallback = styled.span`
  min-height: 44px;
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Poppins, sans-serif;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
`;
export const Title = styled.h2`
  margin: 20px 0 0;
  color: ${({ theme }) => theme.palette.colors.text};
  font-family: Gilroy, sans-serif;
  font-size: 22px;
  line-height: 1.25;
`;
export const Maintainer = styled.p`
  margin: 7px 0 0;
  color: ${({ theme }) => theme.palette.colors.subdued};
  font-family: Lato, sans-serif;
  font-size: 12px;
`;
export const Description = styled.p`
  flex: 1;
  margin: 16px 0;
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.5;
`;
export const Action = styled.a`
  align-self: flex-start;
  color: ${({ theme }) => theme.palette.blue.main};
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 800;
  text-decoration: none;
  &:hover { text-decoration: underline; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 3px; }
`;
export const Status = styled.span`
  align-self: flex-start;
  padding: 5px 8px;
  border-radius: 999px;
  background: ${({ theme }) => theme.palette.colors.badgeMuted};
  color: ${({ theme }) => theme.palette.colors.subdued};
  font-family: Poppins, sans-serif;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;
